import React from 'react'
import { Row, Col, Divider } from 'antd'
import IntlMessages from '../../src/util/IntlMessages'
import _ from 'lodash'
import {
  isEmptyObject,
  getDecryptID,
  formatDigits,
  customParse,
  parseFloatCustom,
  parseIntCustom,
  fetchCurrentSalesOrder
} from '../appRedux/actions/GlobalMethods'
import Barcode from 'react-barcode'
import moment from 'moment'
import {
  PRINT_CONST_FOOTER_1,
  PRINT_CONST_FOOTER_2
  // REACT_APP_PRINT_CONST_FOOTER_3
} from '../constants/StoreSetting'
import { env } from '../env'

const { REACT_APP_PRINT_CONST_FOOTER_3 } = env

export class StandardThermalReceipt extends React.PureComponent {
  render () {
    const {
      outletName,
      registerName,
      getIsTaxExclusive,
      allowPrintNote,
      allowDiscountShow
    } = this.props
    const decimal = this.props.decimal ? this.props.decimal : 2
    const templateData = this.props.templateData
      ? this.props.templateData
      : false
    const data = this.props.data ? this.props.data : false
    const currData = this.props.currData
      ? this.props.currData
      : {
          currencyCode: ''
        }
    const today =
      data && data.sellDate
        ? moment(data.sellDate).format('LLLL')
        : moment().format('LLLL')
    // const objToday = new Date(),
    //   weekday = new Array(
    //     "Sunday",
    //     "Monday",
    //     "Tuesday",
    //     "Wednesday",
    //     "Thursday",
    //     "Friday",
    //     "Saturday"
    //   ),
    //   dayOfWeek = weekday[objToday.getDay()],
    //   domEnder = (function () {
    //     var a = objToday;
    //     if (/1/.test(parseInt((a + "").charAt(0)))) return "th";
    //     a = parseInt((a + "").charAt(1));
    //     return 1 == a ? "st" : 2 == a ? "nd" : 3 == a ? "rd" : "th";
    //   })(),
    //   dayOfMonth =
    //     today + (objToday.getDate() < 10)
    //       ? "0" + objToday.getDate() + domEnder
    //       : objToday.getDate() + domEnder,
    //   months = new Array(
    //     "January",
    //     "February",
    //     "March",
    //     "April",
    //     "May",
    //     "June",
    //     "July",
    //     "August",
    //     "September",
    //     "October",
    //     "November",
    //     "December"
    //   ),
    //   curMonth = months[objToday.getMonth()],
    //   curYear = objToday.getFullYear(),
    //   curHour =
    //     objToday.getHours() > 12
    //       ? objToday.getHours() - 12
    //       : objToday.getHours() < 10
    //         ? "0" + objToday.getHours()
    //         : objToday.getHours(),
    //   curMinute =
    //     objToday.getMinutes() < 10
    //       ? "0" + objToday.getMinutes()
    //       : objToday.getMinutes(),
    //   curSeconds =
    //     objToday.getSeconds() < 10
    //       ? "0" + objToday.getSeconds()
    //       : objToday.getSeconds(),
    //   curMeridiem = objToday.getHours() > 12 ? "PM" : "AM";
    // const today =
    //   dayOfMonth +
    //   " of " +
    //   curMonth +
    //   ", " +
    //   curYear +
    //   " " +
    //   dayOfWeek +
    //   " " +
    //   curHour +
    //   ":" +
    //   curMinute +
    //   "." +
    //   curSeconds +
    //   " " +
    //   curMeridiem;
    return (
      <>
        {templateData ? (
          <div className='custom-print-outer-layout'>
            <div>
              <Row justify='center'>
                <Col>
                  {templateData.headImageURL && (
                    <>
                      <img src={templateData.headImageURL} alt='avatar' />
                    </>
                  )}
                </Col>
              </Row>
              <Row justify='center'>
                <Col>
                  {templateData.headInfoHtml &&
                    !templateData.headInfoHtml.includes('null') && (
                      <div
                        className='reciept-font-size-danger'
                        dangerouslySetInnerHTML={{
                          __html: templateData.headInfoHtml
                        }}
                      />
                    )}
                </Col>
              </Row>
              {templateData.showOutlet && outletName && outletName != '' && (
                <Row justify='center'>
                  <Col>
                    <h2 className='reciept-font-size'>
                      <strong>{outletName}</strong>
                    </h2>
                  </Col>
                </Row>
              )}
              {templateData.isDisplayServedBy && (
                <Row justify='center' style={{ marginLeft: 5 }}>
                  <Col>
                    <h3 className='reciept-font-size'>
                      <IntlMessages id='sell.thermalprint.servedby' />{' '}
                      {templateData.servedByLabel}{' '}
                      {`${data && data.soldBy ? data.soldBy : 'User'}`}
                    </h3>
                  </Col>
                </Row>
              )}
              {templateData.showRegister && (
                <Row justify='center' style={{ marginLeft: 5 }}>
                  <Col>
                    <h3 className='reciept-font-size'>
                      {registerName && registerName != '' && (
                        <>{registerName}</>
                      )}
                    </h3>
                  </Col>
                </Row>
              )}

              {data && data.isRepeat && (
                <Row justify='center' style={{ marginTop: 6, marginBottom: 6 }}>
                  <Col>
                    <h3 className='reciept-font-size'>
                      <h3 className='reciept-font-size'>{`* * * Reprint * * *`}</h3>
                    </h3>
                  </Col>
                </Row>
              )}

              <Divider dashed={true} style={{ backgroundColor: 'black' }} />

              <Row justify='center'>
                <Col>
                  <h3 className='reciept-font-size'>
                    {templateData.invoiceNoPrefix
                      ? `${templateData.invoiceNoPrefix} `
                      : 'Receipt '}
                    #{data.receipt ? ` ${data.receipt}` : ''}
                  </h3>
                </Col>
              </Row>

              {templateData.showDatetime && (
                <Row justify='center'>
                  <Col>
                    <h3 className='reciept-font-size'>{today}</h3>
                  </Col>
                </Row>
              )}

              {(data.saleNature && data.saleNature != '') ||
              data.isRefundSale ? (
                <Row justify='center'>
                  <Col>
                    <h3 className='reciept-font-size'>
                      <strong>
                        {data.saleNature && data.saleNature != ''
                          ? `(${data.saleNature})`
                          : ''}
                        {data.isRefundSale ? `RETURN SALE` : ''}
                      </strong>
                    </h3>
                  </Col>
                </Row>
              ) : (
                <></>
              )}

              {/* {data.receipt && (
                <Row justify="center">
                  <Col>
                    {templateData.invoiceNoPrefix && (
                      <h3 className="reciept-font-size">
                        <strong>
                          {`Receipt: #${data.receipt} `}
                          {data.saleNature && data.saleNature != ""
                            ? `(${data.saleNature})`
                            : ""}
                          {data.isRefundSale ? `RETURN SALE` : ""}
                        </strong>
                      </h3>
                    )}
                  </Col>
                </Row>
              )} */}

              {/* <Row justify="center">
                <Col>
                  {today && <h3 className="reciept-font-size">{today}</h3>}
                </Col>
              </Row> */}

              <Row justify='center' gutter={12}>
                {data.sellSelData &&
                  data.sellSelData.length > 0 &&
                  data.sellSelData.map((as, io) => {
                    return (
                      <Col key={io}>
                        <h3 className='reciept-font-size'>
                          {`(${as.groupName ? `${as.groupName}: ` : ''}
                          ${as.attributeName ? `${as.attributeName}` : ''})`}
                        </h3>
                      </Col>
                    )
                  })}
              </Row>

              <Divider dashed={true} style={{ backgroundColor: 'black' }} />

              {data &&
                data.products &&
                data.products.length > 0 &&
                data.products.map((e, key) => {
                  return (
                    <>
                      <div key={key} style={{ marginTop: key > 0 ? -28 : 10 }}>
                        <Row>
                          <Col span={14}>
                            <h4 className='reciept-font-size'>
                              {templateData.showSKU && (
                                <>
                                  {'SKU: '}
                                  {e.SKU ? e.SKU : ''}
                                  {e.quantity
                                    ? ` (${parseIntCustom(e.quantity)})`
                                    : ''}
                                </>
                              )}

                              {templateData.showProductName && (
                                <>
                                  {e.productName ? `${e.productName}` : ''}
                                  {e.quantity
                                    ? ` (${parseIntCustom(e.quantity)})`
                                    : ''}
                                </>
                              )}

                              {templateData.showProductNameAndSKU && (
                                <>
                                  {e.productName ? `${e.productName}` : ''}
                                  {' / '}
                                  {'SKU: '}
                                  {e.SKU ? e.SKU : ''}
                                  {e.quantity
                                    ? ` (${parseIntCustom(e.quantity)})`
                                    : ''}
                                </>
                              )}

                              <span className='reciept-font-size-time'>
                                {' x '}
                                {e.totalPriceReceipt
                                  ? `${currData.currencyCode} ${formatDigits(
                                      parseFloatCustom(e.totalPriceReceipt) /
                                        parseFloatCustom(e.quantity),
                                      decimal
                                    )}`
                                  : ''}
                              </span>
                            </h4>
                          </Col>

                          <Col span={10}>
                            <h3
                              style={{ float: 'right', marginRight: '2px' }}
                              className='reciept-font-size'
                            >
                              {e.totalPriceReceipt
                                ? `${currData.currencyCode} ${e.totalPriceReceipt}`
                                : ''}
                              {e.taxCode ? ` ${e.taxCode}` : ''}
                            </h3>
                          </Col>
                        </Row>

                        {/* <Row>
                          <Col span={12} push={1}>
                            <h4 className="reciept-font-size">
                              {e.quantity ? e.quantity : ""}
                              {" @ "}
                              {e.totalPriceReceipt
                                ? `${currData.currencyCode} ${e.totalPriceReceipt}`
                                : ""}
                            </h4>
                          </Col>

                          <Col span={12}>
                            <h3
                              style={{ float: "right", marginRight: "2px" }}
                              className="reciept-font-size"
                            >
                              {e.totalPriceReceipt
                                ? `${currData.currencyCode} ${e.totalPriceReceipt}`
                                : ""}
                            </h3>
                          </Col>
                        </Row> */}

                        {allowDiscountShow && (
                          <Row>
                            <Col span={12} push={1}>
                              {e.salesItemDiscount &&
                                customParse(e.salesItemDiscount) > 0 && (
                                  <p
                                    className='reciept-font-size-time'
                                    style={{ marginTop: -8 }}
                                  >
                                    {`Was: ${currData.currencyCode} 
                          ${formatDigits(
                            customParse(e.totalPriceReceipt / e.quantity) +
                              customParse(e.salesItemDiscount),
                            decimal
                          )} 
                          Disc: ${e.discountPercentage}% /  ${
                                      currData.currencyCode
                                    } ${formatDigits(
                                      e.salesItemDiscount,
                                      decimal
                                    )}`}
                                  </p>
                                )}
                              {e.promotions &&
                                !isEmptyObject(e.promotions) &&
                                e.promotions.promotionName &&
                                e.promotions.promotionName != '' && (
                                  <span>
                                    <p
                                      className='reciept-font-size-time'
                                      style={{ marginTop: -8 }}
                                    >
                                      {`Promotion: ${
                                        e.promotions.promotionName
                                      } (${
                                        e.promotionPercent
                                          ? `${e.promotionPercent}% / `
                                          : ''
                                      } ${
                                        currData.currencySymbol
                                          ? currData.currencySymbol
                                          : currData.currencyCode
                                          ? currData.currencyCode
                                          : ''
                                      }
                              ${
                                e.promotions.promotionValue
                                  ? formatDigits(
                                      e.promotions.promotionValue / e.quantity,
                                      decimal
                                    )
                                  : '0.00'
                              } off)`}
                                    </p>
                                    {e.promotion &&
                                      e.promotion.promoCodes &&
                                      e.promotion.promoCodes.length > 0 &&
                                      e.promotion.promoCodes.map((ggf, iop) => {
                                        return (
                                          <p
                                            className='reciept-font-size-time'
                                            key={iop}
                                          >
                                            {`Applied Code: ${ggf.codeName}`}
                                          </p>
                                        )
                                      })}
                                  </span>
                                )}
                              {e.priceBookValue &&
                                customParse(e.priceBookValue) > 0 && (
                                  <p
                                    className='reciept-font-size-time'
                                    style={{ marginTop: -8 }}
                                  >
                                    {`Disc: (${
                                      e.priceBookPercent
                                        ? `${e.priceBookPercent}%  / `
                                        : ''
                                    } ${
                                      currData.currencySymbol
                                        ? currData.currencySymbol
                                        : currData.currencyCode
                                        ? currData.currencyCode
                                        : ''
                                    }${formatDigits(
                                      e.priceBookValue / e.quantity,
                                      decimal
                                    )} off)`}
                                  </p>
                                )}
                              {allowPrintNote &&
                                e.productNote &&
                                e.productNote != '' && (
                                  <p className='reciept-font-size-time font-size-smaller'>
                                    <IntlMessages id='sell.sell.note' />
                                    {` ${e.productNote}`}
                                  </p>
                                )}
                            </Col>

                            <Col span={12}>
                              <h3
                                className='reciept-font-size'
                                style={{
                                  float: 'right',
                                  marginRight: '2px',
                                  textDecoration: 'line-through'
                                }}
                              >
                                {e.salesItemDiscount &&
                                customParse(e.salesItemDiscount) > 0
                                  ? `${currData.currencyCode} 
                          ${formatDigits(
                            customParse(e.totalPriceReceipt) +
                              customParse(e.salesItemDiscount * e.quantity),
                            decimal
                          )}`
                                  : ''}
                              </h3>
                            </Col>
                          </Row>
                        )}

                        {/* {templateData.showTaxPerLineItem &&
                          data &&
                          data.taxes &&
                          data.taxes.length > 0 &&
                          data.taxes
                            .filter((a) => a.itemIdentifyID == e.itemIdentifyID)
                            .map((b, key) => {
                              return (
                                <Row key={key} style={{ marginTop: 0 }}>
                                  <Col span={24} push={1}>
                                    <h6 className="reciept-font-size-time">
                                      {`${b.saleTaxName} (${b.taxValue}% / ${currData.currencyCode} ${b.taxPrice})`}
                                    </h6>
                                  </Col>
                                </Row>
                              );
                            })} */}
                      </div>
                    </>
                  )
                })}

              <Divider dashed={true} style={{ backgroundColor: 'black' }} />

              {allowPrintNote && data && data.Notes && (
                <>
                  <Row>
                    <Col span={24}>
                      <h3 className='reciept-font-size'>
                        <strong>NOTE:</strong>
                      </h3>
                      <h4 className='reciept-font-size'>{data.Notes}</h4>
                    </Col>
                  </Row>

                  <Divider dashed={true} style={{ backgroundColor: 'black' }} />
                </>
              )}

              <Row>
                <Col span={12} push={2}>
                  <h3 className='reciept-font-size'>
                    <strong>
                      {templateData.subTotalLabel ? (
                        templateData.subTotalLabel
                      ) : (
                        <IntlMessages id='sell.thermalprint.Subtotal' />
                      )}
                    </strong>
                  </h3>
                </Col>

                <Col span={12}>
                  <h3
                    className='reciept-font-size'
                    style={{ float: 'right', marginRight: '2px' }}
                  >
                    <strong>
                      {data && data.totalPrice
                        ? `${currData.currencyCode} 
                  ${formatDigits(
                    customParse(data.totalPrice) +
                      (data.additionalDiscount &&
                      data.additionalDiscount != '0.00'
                        ? customParse(data.additionalDiscount)
                        : 0) -
                      customParse(data.totalTax),
                    decimal
                  )}`
                        : '0.00'}
                    </strong>
                  </h3>
                </Col>
              </Row>

              {data.additionalDiscount && data.additionalDiscount != '' && (
                <Row>
                  <Col span={12} push={2}>
                    <h3 className='reciept-font-size'>
                      <IntlMessages id='sell.salehistory.adddis' />
                    </h3>
                  </Col>

                  <Col span={12}>
                    <h3
                      className='reciept-font-size'
                      style={{ float: 'right', marginRight: '2px' }}
                    >
                      {`${currData.currencyCode} ${
                        data.additionalDiscount &&
                        data.additionalDiscount.includes('-')
                          ? data.additionalDiscount.replace('-', '')
                          : data.additionalDiscount
                      }`}
                    </h3>
                  </Col>
                </Row>
              )}

              {templateData.showTaxTotals && (
                <>
                  <Row>
                    <Col span={12} push={2}>
                      <h3 className='reciept-font-size'>
                        <strong>
                          {templateData.taxTotalLabel ? (
                            `${templateData.taxTotalLabel} ${
                              data && data.taxesSum && data.taxesSum.length > 0
                                ? ` (${data.taxesSum.length} Taxes)`
                                : ``
                            }`
                          ) : (
                            <IntlMessages id='sell.thermalprint.totltax' />
                          )}
                        </strong>
                      </h3>
                    </Col>

                    <Col span={12}>
                      <h3
                        className='reciept-font-size'
                        style={{ float: 'right', marginRight: '2px' }}
                      >
                        <strong>
                          {data && data.totalTax
                            ? `${currData.currencyCode} ${data.totalTax}`
                            : '0.00'}
                        </strong>
                      </h3>
                    </Col>
                  </Row>

                  {data && data.taxesSum && data.taxesSum.length > 0 ? (
                    data.taxesSum.map((e, key) => {
                      return (
                        <Row key={key}>
                          <Col span={12} push={3}>
                            <h4 className='reciept-font-size'>
                              {e.saleTaxName
                                ? `${e.saleTaxName} ${
                                    e.taxCode ? e.taxCode : ''
                                  }   (${e.isFix ? e.fixRate : e.taxValue}
                                  ${e.isFix ? ' FIX' : '%'})`
                                : ''}
                            </h4>
                          </Col>

                          <Col span={12}>
                            {(getDecryptID(data.sSalesOrderStatusID) ==
                              getDecryptID(
                                fetchCurrentSalesOrder('On Account, completed')
                              ) ||
                              getDecryptID(data.sSalesOrderStatusID) ==
                                getDecryptID(
                                  fetchCurrentSalesOrder('Layby, completed')
                                )) &&
                            data.salesOrderDiscountPrice &&
                            data.salesOrderDiscountPrice != '0.00' ? (
                              <></>
                            ) : data.isRefundSale &&
                              data.additionalDiscount &&
                              data.additionalDiscount != '' ? (
                              <></>
                            ) : (
                              <>
                                <h3
                                  style={{ float: 'right', marginRight: '2px' }}
                                  className='reciept-font-size'
                                >
                                  {e.taxPrice
                                    ? `${currData.currencyCode} ${e.taxPrice}`
                                    : ''}
                                </h3>
                              </>
                            )}
                          </Col>
                        </Row>
                      )
                    })
                  ) : (
                    <Row>
                      <Col span={24} push={2}>
                        <h3
                          className='reciept-font-size'
                          style={{ marginLeft: '10px' }}
                        >
                          <IntlMessages id='sell.salehistory.notax' />
                        </h3>
                      </Col>
                    </Row>
                  )}

                  {/* {data && data.taxes && data.taxes.length > 0 ? (
              _.uniqBy(data.taxes, "saleTaxName").map((d, key) => {
                return (
                  <>
                    <Row key={key}>
                      <Col span={12} push={2}>
                        <h3 style={{ marginLeft: "10px" }}>
                          {d.saleTaxName
                            ? `${d.saleTaxName} ${d.taxValue ? ` (${d.taxValue}%)` : ``
                            }`
                            : ""}
                        </h3>
                      </Col>

                      <Col span={12}>
                        <h3
                          style={{ float: "right", marginRight: "2px" }}
                        >
                          {d.taxPrice
                            ? `${currData.currencyCode} ${d.taxPrice}`
                            : ""}
                        </h3>
                      </Col>
                    </Row>
                  </>
                );
              })
            ) : (
              <Row>
                <Col span={24} push={2}>
                  <h3 style={{ marginLeft: "10px" }}>
                    <IntlMessages id="sell.salehistory.notax" />
                  </h3>
                </Col>
              </Row>
            )} */}
                </>
              )}

              <Divider style={{ backgroundColor: 'black' }} />

              <Row>
                <Col span={12}>
                  <h3 className='reciept-font-size'>
                    <strong>
                      {templateData.totalLabel ? (
                        `${templateData.totalLabel} ${
                          data && data.totalItems && data.totalItems > 0
                            ? ` (${data.totalItems} items)`
                            : ``
                        }`
                      ) : (
                        <IntlMessages id='sell.thermalprint.totl' />
                      )}
                    </strong>
                  </h3>
                </Col>

                <Col span={12}>
                  <h3
                    className='reciept-font-size'
                    style={{ float: 'right', marginRight: '2px' }}
                  >
                    <strong>
                      {data && data.totalPrice
                        ? `${currData.currencyCode} ${data.totalPrice}`
                        : ''}
                    </strong>
                  </h3>
                </Col>
              </Row>

              <Divider style={{ backgroundColor: 'black' }} />

              {data && data.payments && data.payments.length > 0 && (
                <Row style={{ marginBottom: 10 }}>
                  <Col span={24}>
                    <p className='reciept-font-size'>
                      <strong>
                        <IntlMessages id='sell.thermalprint.paymentsthrough' />
                      </strong>
                    </p>
                  </Col>
                </Row>
              )}

              {data &&
                data.payments &&
                data.payments.length > 0 &&
                data.payments.map((pay, key) => {
                  return (
                    <Row key={key}>
                      <Col span={8}>
                        <h3 className='reciept-font-size'>
                          {pay.paymentName ? pay.paymentName : ''}
                        </h3>
                      </Col>

                      <Col span={10}>
                        <h4 className='reciept-font-size-time'>
                          {pay.paymentOn ? pay.paymentOn : ''}
                        </h4>
                      </Col>

                      <Col span={6}>
                        <h3
                          className='reciept-font-size'
                          style={{ float: 'right' }}
                        >
                          {pay.amount
                            ? `${currData.currencyCode} ${pay.amount}`
                            : ''}
                        </h3>
                      </Col>
                    </Row>
                  )
                })}

              <Row>
                <Col span={12} push={2}>
                  <Divider style={{ backgroundColor: 'black' }} />
                  <h3 className='reciept-font-size'>
                    {templateData.toPayLabel ? (
                      templateData.toPayLabel
                    ) : (
                      <IntlMessages id='sell.thermalprint.topay' />
                    )}
                  </h3>
                </Col>

                <Col span={12}>
                  <Divider style={{ backgroundColor: 'black' }} />
                  <h3
                    className='reciept-font-size'
                    style={{ float: 'right', marginRight: '2px' }}
                  >
                    {data.toPay && data.toPay != ''
                      ? `${currData.currencyCode} ${data.toPay}`
                      : '0.00'}
                  </h3>
                </Col>
              </Row>

              {templateData.showLoyaltyEarned &&
                data.totalLoyaltyValue &&
                data.totalLoyaltyValue > 0 && (
                  <Row>
                    <Col span={12} push={2}>
                      <Divider style={{ backgroundColor: 'black' }} />
                      <h3 className='reciept-font-size'>
                        {templateData.loyaltyEarnedLabel ? (
                          templateData.loyaltyEarnedLabel
                        ) : (
                          <IntlMessages id='template.loyalty.earned' />
                        )}
                      </h3>
                    </Col>

                    <Col span={12}>
                      <Divider style={{ backgroundColor: 'black' }} />
                      <h3
                        className='reciept-font-size'
                        style={{ float: 'right', marginRight: '2px' }}
                      >
                        {currData.currencyCode}{' '}
                        {formatDigits(data.totalLoyaltyValue, decimal)}
                      </h3>
                    </Col>
                  </Row>
                )}

              {data.change && customParse(data.change) > 0 && (
                <Row>
                  <Divider
                    style={{
                      backgroundColor: 'black',
                      borderBottom: '1px dotted #ff0000'
                    }}
                  />
                  <Col span={12} push={2}>
                    <h3 className='reciept-font-size'>
                      {templateData.changeLabel ? (
                        templateData.changeLabel
                      ) : (
                        <IntlMessages id='sell.thermalprint.change' />
                      )}
                    </h3>
                  </Col>

                  <Col span={12}>
                    <h3
                      className='reciept-font-size'
                      style={{ float: 'right', marginRight: '2px' }}
                    >
                      {data && data.change
                        ? `${currData.currencyCode} ${data.change}`
                        : '0.00'}
                    </h3>
                  </Col>
                </Row>
              )}

              <Divider style={{ backgroundColor: 'black' }} />

              {allowDiscountShow &&
                data.totalSavings &&
                customParse(data.totalSavings) > 0 && (
                  <>
                    <Row>
                      <Col span={12}>
                        <h3 className='reciept-font-size'>
                          <strong>
                            <IntlMessages id='sell.thermalprint.totalsavings' />
                          </strong>
                        </h3>
                      </Col>

                      <Col span={12}>
                        <h3
                          className='reciept-font-size'
                          style={{ float: 'right', marginRight: '2px' }}
                        >
                          <strong>
                            {`${currData.currencyCode} ${data.totalSavings}`}
                          </strong>
                        </h3>
                      </Col>
                    </Row>
                    <Divider style={{ backgroundColor: 'black' }} />
                  </>
                )}

              {data &&
                (data.customerEmail ||
                  data.customerPhone ||
                  data.customerAddress ||
                  data.customerGroupName ||
                  data.firstName ||
                  data.lastName) &&
                templateData.showCustomerDetails && (
                  <>
                    <Row justify='center'>
                      <Col>
                        <h2 className='reciept-font-size'>
                          <strong>
                            <IntlMessages id='sell.thermalprint.customers' />
                          </strong>
                        </h2>
                      </Col>
                    </Row>
                    <div>
                      {data.customerGroupName &&
                        templateData.showCustomerCompany && (
                          <Row>
                            <Col span={4}>
                              <h3 className='reciept-font-size'>
                                <strong>
                                  <IntlMessages id='sell.thermalprint.groupname' />
                                </strong>
                              </h3>
                            </Col>

                            <Col span={20}>
                              <h3 className='reciept-font-size'>
                                {data.customerGroupName}
                              </h3>
                            </Col>
                          </Row>
                        )}
                      {(data.firstName || data.lastName) &&
                        templateData.showCustomerName && (
                          <Row>
                            <Col span={4}>
                              <h3 className='reciept-font-size'>
                                <strong>
                                  <IntlMessages id='sell.thermalprint.cusname' />
                                </strong>
                              </h3>
                            </Col>

                            <Col span={20}>
                              <h3 className='reciept-font-size'>
                                {data.firstName + ' ' + data.lastName}
                              </h3>
                            </Col>
                          </Row>
                        )}
                      {data.customerCode && templateData.showCustomerCode && (
                        <Row>
                          <Col span={4}>
                            <h3 className='reciept-font-size'>
                              <strong>
                                <IntlMessages id='sell.thermalprint.cuscode' />
                              </strong>
                            </h3>
                          </Col>

                          <Col span={20}>
                            <h3 className='reciept-font-size'>
                              {data.customerCode}
                            </h3>
                          </Col>
                        </Row>
                      )}
                      {data.customerEmail && templateData.showCustomerEmail && (
                        <Row>
                          <Col span={4}>
                            <h3 className='reciept-font-size'>
                              <strong>
                                <IntlMessages id='sell.thermalprint.cusemail' />
                              </strong>
                            </h3>
                          </Col>

                          <Col span={20}>
                            <h3 className='reciept-font-size'>
                              {data.customerEmail}
                            </h3>
                          </Col>
                        </Row>
                      )}
                      {data.customerPhone && templateData.showCustomerPhone && (
                        <Row>
                          <Col span={4}>
                            <h3 className='reciept-font-size'>
                              <strong>
                                <IntlMessages id='sell.thermalprint.cusphone' />
                              </strong>
                            </h3>
                          </Col>

                          <Col span={20}>
                            <h3 className='reciept-font-size'>
                              {data.customerPhone}
                            </h3>
                          </Col>
                        </Row>
                      )}
                      {data.customerAddress &&
                        templateData.showCustomerAddress && (
                          <Row>
                            <Col span={4}>
                              <h3 className='reciept-font-size'>
                                <strong>
                                  <IntlMessages id='sell.thermalprint.cusaddress' />
                                </strong>
                              </h3>
                            </Col>

                            <Col span={20}>
                              <h3 className='reciept-font-size'>
                                {data.customerAddress}
                              </h3>
                            </Col>
                          </Row>
                        )}
                      <Divider style={{ backgroundColor: 'black' }} />
                    </div>
                  </>
                )}
              {data.barcode && (
                <Row
                  justify='center'
                  style={{ marginBottom: '0px !important' }}
                >
                  <Col>
                    <Barcode
                      value={data.barcode}
                      width={5}
                      textAlign={'center'}
                      fontSize={15}
                      displayValue={false}
                      marginBottom={0}
                    />
                  </Col>
                </Row>
              )}
              {/* {(data.saleid || data.indexKey) && (
                <Row
                  justify='center'
                  style={{ marginBottom: '0px !important' }}
                >
                  <Col>
                    <Barcode
                      value={data.saleid ? data.saleid : data.indexKey}
                      width={5}
                      textAlign={'center'}
                      fontSize={15}
                      displayValue={false}
                      marginBottom={0}
                    />
                  </Col>
                </Row>
              )} */}
              {(data.saleid || data.indexKey) && (
                <Row
                  justify='center'
                  style={{ marginBottom: '0px !important' }}
                >
                  <Col>
                    <h5 className='reciept-font-size-time'>
                      {`Ref no ${data.saleid ? data.saleid : data.indexKey}`}
                    </h5>
                    {data.isOffline ? (
                      <>
                        <h5 className='reciept-font-size-time'>
                          {`Offline Sale`}
                        </h5>
                        {data.saleid && data.indexKey ? (
                          <h5 className='reciept-font-size-time'>
                            {data.indexKey}
                          </h5>
                        ) : (
                          ''
                        )}
                      </>
                    ) : (
                      ''
                    )}
                  </Col>
                </Row>
              )}

              {templateData.showLoyaltyMessage && templateData.loyaltyMessage && (
                <Row justify='center'>
                  <Divider style={{ backgroundColor: 'black' }} />
                  <h3 className='reciept-font-size' style={{ marginLeft: 5 }}>
                    {templateData.loyaltyMessage}
                  </h3>
                </Row>
              )}

              {/* <Row justify="center">
                <h3 className="reciept-font-size">
                  {templateData.loyaltyMessage
                    ? templateData.loyaltyMessage
                    : `Register your details with ${data && data.storeName ? data.storeName : "us"
                    } for Loyalty Program:`}
                </h3>
              </Row> */}

              {templateData.footerHtml &&
                !templateData.footerHtml.includes('null') && (
                  <Row
                    justify='center'
                    // style={{
                    //   display: 'flex',
                    //   flexDirection: 'column',
                    //   marginTop: 4,
                    //   marginLeft: 5
                    // }}
                  >
                    <Col>
                      <div
                        className='reciept-font-size-danger'
                        dangerouslySetInnerHTML={{
                          __html: templateData.footerHtml
                        }}
                      />
                    </Col>
                  </Row>
                )}

              <div style={{ marginTop: 32 }}>
                <h2
                  className='reciept-font-size'
                  style={{ textAlign: 'center' }}
                >
                  <strong>{PRINT_CONST_FOOTER_1}</strong>
                </h2>
                <h3
                  className='reciept-font-size'
                  style={{ textAlign: 'center' }}
                >
                  {PRINT_CONST_FOOTER_2}
                </h3>
                <h3
                  className='reciept-font-size'
                  style={{ textAlign: 'center' }}
                >
                  {REACT_APP_PRINT_CONST_FOOTER_3}
                </h3>
              </div>
            </div>
          </div>
        ) : (
          <h1>
            <IntlMessages id='sell.openclose.connectionlost' />
          </h1>
        )}
      </>
    )
  }
}

// import React, { memo, pure } from "react";
// import {
//   Button,
//   Divider,
//   Row,
//   Col,
//   message,
//   Form,
//   Spin,
//   Table,
//   Avatar,
// } from "antd";
// // import IntlMessages from "../../../util/IntlMessages";
// import { useHistory } from "react-router-dom";
// import { useDispatch, useStore, useSelector } from "react-redux";

// const PrintSummary = (props) => {
//   const cashManageID = props.cashManageID;
//   const history = useHistory();
//   const store = useStore();
//   const [form] = Form.useForm();
//   const dispatch = useDispatch();

//   return (
//     <table>
//       <thead>
//         <th>column 1</th>
//         <th>column 2</th>
//         <th>column 3</th>
//       </thead>
//       <tbody>
//         <tr>
//           <td>data 1</td>
//           <td>data 2</td>
//           <td>data 3</td>
//         </tr>
//       </tbody>
//     </table>
//   );
// };

// export default memo(PrintSummary);
